(ns dre.components.widget.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [re-frame.core :as rf]
   [dre.components.widget.db :as wdb]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))


(def db-path :widget)

;; -- Events

(rf/reg-event-fx
 ::set-selection
 [(rf/path db-path)]
 (fn-traced
  [{db :db} [_ widget-id selection-key v]]
  {:db (assoc-in db [widget-id selection-key] v)}))

(rf/reg-event-fx
 ::set-export-count
 [(rf/path db-path)]
 (fn-traced
  [{db :db} [_ widget-id value]]
  {:db (assoc-in db [widget-id :export-count] value)}))


;; -- Subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (db-path db)))

(rf/reg-sub
 ::selection
 :<- [::state]
 (fn [state [_ id selection-key]]
   (get-in state [id (or selection-key :selection)] nil)))

(rf/reg-sub
 ::get-export-count
 :<- [::state]
 (fn [state [_ widget-id]]
   (let [default-export-count (-> (wdb/get-widget-options-by-id widget-id)
                                  :export-counts
                                  first
                                  :id)]
     (if-let [export-count (get-in state [widget-id :export-count])]
       export-count
       default-export-count))))
